import { EventTargetFallback as a } from "./eventTargetFallback.js";
import { SubmenuMenuItem as h } from "./itemTypes.js";
var p = /* @__PURE__ */ ((s) => (s.ItemsUpdated = "items-updated", s))(p || {});
let l = EventTarget;
try {
  new EventTarget();
} catch {
  l = a;
}
class d extends l {
  static menu = new d();
  static getApplicationMenu = () => this.menu;
  static setApplicationMenu = (i) => {
    this.menu = i;
  };
  static buildFromTemplate(i) {
    const e = new d(), n = i.map((t) => "submenu" in t ? new h(t) : t);
    return e.items = c(n), e;
  }
  _items = [];
  get items() {
    return this._items;
  }
  set items(i) {
    this._items = i, this.dispatchEvent(new Event(
      "items-updated"
      /* ItemsUpdated */
    ));
  }
  append(i) {
    const { before: e, after: n } = i;
    let t = -1;
    e && (t = m(e, this._items), t !== -1 && this._items.splice(t, 0, i)), n && t === -1 && (t = m(n, this._items), t !== -1 && this._items.splice(t + 1, 0, i)), t === -1 && this._items.push(i), this.items = c(this._items, i);
  }
  getMenuItemById(i) {
    for (const e of this.items) {
      if (e.id === i)
        return e;
      if (e.type === "submenu") {
        const n = e.submenu.getMenuItemById(i);
        if (n)
          return n;
      }
    }
    return null;
  }
  getSubmenuMenuItemById(i) {
    for (const e of this.items)
      if (e.id === i && e.type === "submenu")
        return e;
    return null;
  }
}
function m(s, i) {
  return i.findIndex((e) => e.id && s.includes(e.id) ? !0 : s.includes(e.label));
}
function o(s, i, e) {
  for (let n = 0; n < s.length; ++n)
    if (e.has(s[n]))
      return i.findIndex((t) => t.id === s[n] || t.label === s[n]);
  return -1;
}
function c(s, i) {
  const e = [...s], n = /* @__PURE__ */ new Set();
  i ? (i.id && n.add(i.id), n.add(i.label)) : s.forEach((t) => {
    t.id && n.add(t.id), n.add(t.label);
  });
  for (let t = 0; t < s.length; ++t) {
    const { after: r, before: f } = s[t];
    if (f) {
      const u = o(f, s, n);
      if (u !== -1) {
        delete e[t], e[u] = [s[t], e[u]];
        continue;
      }
    }
    if (r) {
      const u = o(r, s, n);
      if (u !== -1) {
        delete e[t], e[u] = [e[u], s[t]];
        continue;
      }
    }
  }
  return e.flat();
}
export {
  d as ApplicationMenu,
  p as ApplicationMenuEvents,
  c as orderItems
};
